import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { ToggleButton } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import { useAppDispatch } from 'app/hooks'
import { setDisplayTheme } from 'features/ui/uiSlice'
import { ToggleLabel } from 'pages/dashboard/main/index.css'
import { heapTrack, HeapEvent, HeapEventPageValue } from 'utils/heapUtils'

export const StyledLabelText = styled.div<{ mode: Theme }>`
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[14].lineHeight};
  color: ${({ mode }) => sys[mode].text.primary};
  margin-right: 4px;
`

const DarkModeToggle = ({ page }: { page: HeapEventPageValue }) => {
  const { t } = useTranslation()
  const displayTheme = useDisplayTheme() as Theme
  const dispatch = useAppDispatch()

  return (
    <ToggleLabel>
      <StyledLabelText mode={displayTheme}>{t('darkMode')}</StyledLabelText>
      <ToggleButton
        mode={displayTheme}
        checked={displayTheme === 'dark'}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const selectedTheme = e.target.checked ? 'dark' : 'light'
          dispatch(setDisplayTheme(selectedTheme))
          heapTrack(HeapEvent.V4LightDarkModeToggle, { selectedTheme, page })
        }}
      />
    </ToggleLabel>
  )
}

export default DarkModeToggle
